import { api } from '../api';
import type { RequestOptions } from '../api';
import type { GeoCoordinates } from './location.types';

export const fetchGeoCoordinates = (
  options?: RequestOptions
): Promise<GeoCoordinates> =>
  api.get<GeoCoordinates>('/v1/coordinates', null, options);
